import { useMutation } from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/api-key'

const getUserExistsKey = () => ['userExits']

const userExistsQuery = /** GraphQl */ `
  query UserExists($username: String!) {
    userExists(username: $username)
  }
`

export function useUserExistsMutation() {
  return useMutation({
    mutationKey: getUserExistsKey(),
    mutationFn: async (variables: { email: string }) => {
      const { email } = variables
      const data = await graphql({
        query: userExistsQuery,
        variables: {
          username: email
        }
      })
      return data.userExists
    }
  })
}
